/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./userRelations.vue?vue&type=template&id=01997182"
import script from "./userRelations.vue?vue&type=script&lang=js"
export * from "./userRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports